import { Bell, MessageSquare } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { slackWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  slackWeb,
  {
    SlackSettingsPage: () => import('./SlackSettingsPage'),
    SlackFlowTriggerSummary: () => import('./SlackFlowTriggerSummary'),
    SlackThreadAssociationChip: () => import('./SlackThreadAssociationChip'),
    SlackNotificationSettings: () => import('./SlackNotificationSettings'),
    SlackWorkspaceCardPreview: () =>
      import('./SlackWorkspaceCardPreview').then((m) => ({
        default: m.SlackWorkspaceCardPreview,
      })),
  },
  {
    icons: { Bell, MessageSquare },
  },
);
